module.exports = __webpack_public_path__ + "static/zhongli-banner-49525119478d649ffefe7afdb3c8a989.png";